import React, { useEffect, useRef } from 'react';
import { TooltipView } from 'atoms/Tooltip/index';
import { CHECKOUT_CONSTANTS } from 'common/constants/SharedConstants';

export const MaterialTextInput = props => {
  const {
    placeholder = '',
    labelClassName = '',
    inputClassName = '',
    helperTextClassName = '',
    containerClassName = '',
    inputTestId = '',
    labelTestId = '',
    onKeyPressHandler = null,
    error = false,
    helperText = '',
    ariaLabel,
    ariaRequired = '',
    autoComplete = '',
    toolTipText = '',
    toolTipSrc = '',
    errorIcon = '',
    errorIconClassName,
    isMandatory = false,
    setFocus = false,
    showCurrencySymbol = false,
    currencySymbol = '',
    readOnly = false,
    innerRef = null,
    dispalyErrorMessage = true,
    ...rest
  } = props;
  const inputRef = useRef(null);

  useEffect(() => {
    setFocus && inputRef?.current?.focus();
  }, [setFocus]);

  return (
    <div className={`field material-input ${containerClassName} `}>
      {dispalyErrorMessage && error && (
        <span className={helperTextClassName} role='alert'>
          {errorIcon ? (
            <div className={errorIconClassName}>
              <div>
                <img src={errorIcon} alt='Error visible' />
              </div>
              <div>{helperText}</div>
            </div>
          ) : (
            helperText
          )}
        </span>
      )}

      {showCurrencySymbol && <span className='currency-field'>{currencySymbol}</span>}

      <input
        ref={innerRef || inputRef}
        className={inputClassName}
        id={`mt-input-${props?.name || placeholder}`}
        name={`mt-input-${props?.name || placeholder}`}
        placeholder={placeholder}
        onKeyPress={onKeyPressHandler}
        data-testid={inputTestId}
        aria-required={ariaRequired}
        autoComplete={autoComplete}
        {...rest}
        readOnly={readOnly}
      ></input>

      <label data-testid={labelTestId} className={labelClassName} htmlFor={`mt-input-${props?.name || placeholder}`}>
        {placeholder}
        {isMandatory && CHECKOUT_CONSTANTS.STAR}
      </label>

      {toolTipText && (
        <span className='tool-tip-position'>
          <TooltipView placement='top' title={toolTipText}>
            <img className='tooltip-view' src={toolTipSrc} alt='tooltip' />
          </TooltipView>
        </span>
      )}
    </div>
  );
};
